import './PageLoader.scss'
import { clx } from '../clx'
import { Spinner } from '../Spinner'

export interface PageLoaderProps {
  /** The status announced to assistive technology. Default "Loading". */
  label?: string
  className?: string
}

/**
 * The full-page loading state (react-admin's `<Loading>`): a large spinner in
 * the centre of the viewport, for when there is no page yet to put a
 * skeleton in (the first lazily loaded route, the auth gate).
 */
export function PageLoader({ label = 'Loading', className }: PageLoaderProps) {
  return (
    <div className={clx('page-loader', className)}>
      <Spinner size="lg" label={label} />
    </div>
  )
}
